export default __webpack_public_path__ + "static/media/naidi-2-1.a2f23f5b.svg";